export const iframeMessage = message => ({
  type: "IFRAME_MESSAGE",
  message
});
